import React from "react";
import { Link } from "react-router-dom";
import NexWordmark from "@/components/NexWordmark";
import { LIFE_LOGO } from "@/lib/assets";
import { AlertCircle } from "lucide-react";

const CheckoutCancel = () => (
  <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center px-6">
    <div className="w-full max-w-lg text-center">
      <Link to="/" className="inline-flex items-center gap-4 mb-10">
        <img src={LIFE_LOGO} alt="LIFE" className="h-14 w-14 object-contain" />
        <div className="w-px h-12 bg-nex-border" />
        <NexWordmark size="text-3xl" />
      </Link>
      <div className="card-industrial corner-tick p-10">
        <AlertCircle size={40} className="mx-auto text-nex-gold mb-6" />
        <div className="mono-label mb-3">// PAYMENT CANCELLED</div>
        <h1 className="serif-head text-3xl mb-4">No charge made.</h1>
        <p className="text-nex-chrome leading-relaxed mb-8">
          Your consultation fee payment was cancelled. Your Engine Brief is still on file — you can pick this up whenever you&apos;re ready by clicking the link William sent you.
        </p>
        <Link to="/" data-testid="checkout-cancel-home" className="tick-btn-secondary inline-flex">← Back to NEX</Link>
      </div>
    </div>
  </div>
);

export default CheckoutCancel;
